// Select the custom button element
let offCustomBtn = document.querySelector('#shopify-section-sections--23644198797630__image_with_text_eU9B9Q .small-feature-link.button-row__btn');

// Check if the button exists
if (offCustomBtn) {
    offCustomBtn.addEventListener('click', function(event) {
        event.preventDefault();
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', 'Ww9nyC']);
    });
}


// let offCustomBtn = document.querySelector('#shopify-section-sections--23644198797630__image_with_text_eU9B9Q .small-feature-link.button-row__btn');

// if (offCustomBtn) {
//     offCustomBtn.addEventListener('click', function(event) {
//         event.preventDefault(); // Prevent the default action
//         const targetElement = document.querySelector('.needsclick'); // Select the target element
//         if (targetElement) {
//             targetElement.click(); // Trigger a click on the target element
//         } else {
//             console.warn('Element with class "needsclick" not found.');
//         }
//     });
// } else {
//     console.warn('Button with selector "#shopify-section-sections--23644198797630__image_with_text_eU9B9Q .small-feature-link.button-row__btn" not found.');
// }
